/* eslint-disable no-unused-vars */
import React from 'react';
import ModalBase, { ModalProps } from '@mui/material/Modal';
import style from './modal.module.scss';
import cx from 'classnames';
import { Box } from '@mui/material';
import CloseIcon from 'icons/close';

export default function Modal({
  open,
  children,
  onClose,
  className,
  innerSX,
  disableClose = false,
}: ModalProps & {
  innerSX?: any;
  disableClose?: boolean;
}) {
  return (
    <ModalBase
      className={cx(style.modal, className)}
      open={open}
      onClose={onClose}
      disableScrollLock={true}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      disableAutoFocus={true}
      BackdropProps={{
        transitionDuration: {
          enter: 0,
        },
      }}
    >
      <Box
        className={cx(style.container, 'adaptive-editTagModal__box')}
        sx={innerSX}
      >
        {!disableClose ? (
          <CloseIcon
            className={style.mainClose}
            onClick={(e) => {
              if (onClose !== undefined) {
                onClose(e, 'backdropClick');
              }
            }}
          ></CloseIcon>
        ) : (
          ''
        )}
        {children}
      </Box>
    </ModalBase>
  );
}
